export default {
      id: "menu-close-usage",
      viewBox: "0 0 18 12",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#menu-close",
      toString: function () {
        return this.url;
      }
    }